<template>
  <div class="b_inter_wrap">
    <step-status :step="$route.meta.step" class="mt55"></step-status>

    <div class="book_date">
      <!-- <h1 class='words' v-if='$route.query.status=="no_show"'>Dear {{username}}, we didn’t catch you at your scheduled new teacher training time, so we had to cancel the appointment. You may request a new appointment.</h1> -->

      <h4>Request a Teaching Practice Guide Time</h4>

      <div class='choose_timezone'>
        <el-select v-model="time_zone" filterable placeholder="Time Zone＊">
          <el-option v-for="(key,val) in d_time_zone" :label="val" :value="key" :key="key">
          </el-option>
        </el-select>

        <p>The times listed below are presented<br/> according to the time zone you selected. </p>
      </div>

      <div class="date_detail clearfix">
        <div class="calendar_wrapper">
          <!-- <p>{{calendar.items.text}}</p> 选择的时间-->
          <Calendar :show="calendar.show" :type="calendar.items.type" :value="calendar.items.value" :x="calendar.x" :y="calendar.y" :begin="calendar.items.begin" @cancel="dateCancel" @ok="dateOk" :end="calendar.items.end" :sep="calendar.items.sep" :single="calendar.items.single" :rangeValue='calendar.items.rangeValue' :autoclose='calendar.items.autoclose'>
          </Calendar>
        </div>

        <div class="time_quantum clearfix">
          <ul class="clearfix" v-show='hasDate'>
            <li v-for='(time, idx) in time_frame' :class='{active:time.isActive}' @click='frameFn(time.work_hour_value,idx,time.work_start_time)' :key="idx">
              {{time.work_start_time}}-{{time.work_end_time}}
            </li>
          </ul>

          <div class="no_date" v-show='!hasDate'>
            <p>No available times that day, please check other dates.</p>
          </div>
        </div>
      </div>

      <a class="submit" @click='submit'> Submit</a>
    </div>
    <div class="download">
      <ul class="clearfix">
        <li>
          <ac></ac>
        </li>
      </ul>
    </div>
    <!-- Google pixel -->
    <div style="display:inline;">
      <img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/852175291/?label=6w1jCNWDxngQu9OslgM&amp;guid=ON&amp;script=0" />
    </div>
    <!-- status ==no_show -->
    <!-- <div style="display:inline;" v-if='$route.query.status=="no_show"'>
			<img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/852175291/?label=O7kyCNeFxngQu9OslgM&amp;guid=ON&amp;script=0" />
		</div> -->
    <!-- status ==canceled-->
    <div style="display:inline;" v-if='$route.query.status=="canceled"'>
      <img height="1" width="1" style="border-style:none;" alt="" src="//www.googleadservices.com/pagead/conversion/852175291/?label=5q8jCM_HsngQu9OslgM&amp;guid=ON&amp;script=0" />
    </div>
  </div>
</template>
<script>
import Calendar from 'components/common/Calendar.vue'
import ac from 'components/common/ac.vue'

export default {
  name: 'rangeTime',
  components: {
    Calendar,
    ac
  },
  data() {
    return {
      hasDate: false,
      username: '',
      words: {
        cancel: false,
        no_show: false
      },
      // 数据绑定
      calendar: {
        show: true,
        x: 0,
        y: 0,
        items: {
          type: 'date',
          begin: '', // "2015-08-20"
          end: '',
          value: '',
          text: '',
          sep: '-',
          rangeValue: '',
          single: true,
          autoclose: true,
          weeks: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
          months: [
            'Jan',
            'Feb',
            'Mar',
            'Apr',
            'May',
            'Jun',
            'Jul',
            'Aug',
            'Sep',
            'Oct',
            'Nov',
            'Dec'
          ]
        }
      },
      d_time_zone: '', // 时区数据
      time_zone: '', // 选择后的时区字段
      time_detail: '',
      switch_time: '', //php区分时区需要准确的时间（时：分），此参数接收后端返回的时分
      time_frame: [
        /*{// 时间段
        	  'isActive':false,
		      "service_id": "2",
		      "working_date": "2017-04-01",
		      "week": "Sunday",
		      "work_hour_type": "2",
		      "work_hour_value": "1-2",
		      "work_start_time": "00:00",
		      "work_end_time": "00:30"
		    },
		    {
		      'isActive':false,
		      "service_id": "2",
		      "working_date": "2017-04-01",
		      "week": "Sunday",
		      "work_hour_type": "2",
		      "work_hour_value": "3-4",
		      "work_start_time": "01:00",
		      "work_end_time": "01:30"
		    }*/
      ],
      right_date_update: '', //右侧时间段刷新变量;因为当切换时区的时候，日期有时会相同，导致BUG出现
      work_start_time: ''
    }
  },
  methods: {
    frameFn(d, idx, work_start_time) {
      for (var i = 0; i < this.time_frame.length; i++) {
        this.time_frame[i].isActive = false
      }
      this.time_detail = d //传入的时间段
      this.time_frame[idx].isActive = true
      this.work_start_time = work_start_time
    },
    // 打开显示选择器
    open(e, type) {
      // 设置类型
      this.calendar.show = true
      this.calendar.x = e.target.offsetLeft
      this.calendar.y = e.target.offsetTop + e.target.offsetHeight + 8
    },
    dateCancel(obj) {
      this.calendar.show = obj.show
    },
    dateOk(obj) {
      this.calendar.items.text = obj.values[0]
      this.calendar.items.value = obj.values[0]
    },
    submit() {
      let params = new URLSearchParams()
      let _this = this
      let date = this.calendar.items.text + ' ' + this.work_start_time

      //console.log(_this.time_zone,_this.s_date,_this.time_detail,this.pass)
      if (!this.time_zone || !date || !this.time_detail) {
        this.$message.error('Please choose a training session!')
        return
      }
      params.append('timezone', _this.time_zone)
      params.append('working_date', date)
      params.append('working_time', _this.time_detail)
      params.append('action', 'schedule')

      this.axios.post('/tpg/schedule', params).then(d => {
        if (d.data.code == '75000') {
          this.$message.success('Success!')
          this.$router.replace('/tpg?status=assigned')
        } else {
          this.$message.error(d.data.message)
        }
      })
    },
    addZero(n) {
      return n < 10 ? '0' + n : n
    },
    update_right_time() {
      this.time_detail = ''

      let date = this.calendar.items.text + ' ' + this.switch_time // 准确的时间：为php提供条件，以区分准确时区
      this.$http
        .get(
          '/tpg/getTpgTime?timezone=' + this.time_zone + '&working_date=' + date
        )
        .then(
          function(response) {
            if (response.data.code == '75000') {
              this.hasDate = true
              this.time_frame = []
              for (let i = 0; i < response.data.res.length; i++) {
                let arrTime = {}
                arrTime.service_id = response.data.res[i].service_id
                arrTime.working_date = response.data.res[i].working_date
                arrTime.week = response.data.res[i].week
                arrTime.work_end_time = response.data.res[i].work_end_time
                arrTime.work_hour_type = response.data.res[i].work_hour_type
                arrTime.work_hour_value = response.data.res[i].work_hour_value
                arrTime.work_start_time = response.data.res[i].work_start_time
                arrTime.isActive = false
                this.time_frame.push(arrTime)
              }
            } else {
              this.hasDate = false
              //this.$message.error(response.data.message);
              this.time_frame = []
              this.time_detail = ''
            }
          },
          function() {
            console.log('service error')
          }
        )
    }
  },
  created() {
    // 初始化日历时间
    let _this = this

    let date = new Date()

    let yy = date.getFullYear()

    let mm = date.getMonth() + 1

    let dd = date.getDate()

    mm = mm < 10 ? '0' + mm : mm

    dd = dd < 10 ? '0' + dd : dd

    //this.calendar.items.value = yy+'-'+mm+'-'+dd

    //初始化时区
    this.$http.get('/common/getConfig?key=time_zone').then(d => {
      if (d.data.code == '75000') {
        this.d_time_zone = d.data.res.time_zone //获取时区

        this.$http
          .get('/tpg/getTutorInfo') // 获取用户时区

          .then(d => {
            if (d.data.code == '75000') {
              this.time_zone = d.data.res.tutor.time_zone

              this.username = d.data.res.tutor.full_name

              //切换日期，更新时间段
              this.$watch(
                function() {
                  //切换时区，触发的右侧时间段刷新
                  return this.right_date_update
                },
                function() {
                  this.update_right_time()
                }
              )
              this.$watch(
                function() {
                  //切换日历的日期，触发的右侧时间段刷新
                  return this.calendar.items.text
                },
                function() {
                  this.update_right_time()
                }
              )
            } else {
              this.$message.error('making appointments fail.')
            }
          })
      }
    })
  },
  watch: {
    time_zone: function() {
      let _this = this

      //切换时区，更新可选时间
      this.$http.get('/tpg/getTpgDate?timezone=' + this.time_zone).then(d => {
        console.log('watch')
        if (d.data.code == '75000') {
          // 设置时间段
          let dates = d.data.res.cycles
          //格式化第七天的时间类型
          let serve_date =
            new Date(d.data.res.first_date).getTime() +
            (dates * 1 - 1) * 24 * 60 * 60 * 1000

          let dateEnd = new Date(serve_date)

          let year = dateEnd.getFullYear()

          let months = _this.addZero(dateEnd.getMonth() + 1)

          let day = _this.addZero(dateEnd.getDate())

          console.log(
            'd.data.res.first_date:' + d.data.res.first_date,
            'serve_date:' + serve_date,
            'dateEnd:' + dateEnd
          )

          this.calendar.items.end = year + '-' + months + '-' + day //结束时间

          this.calendar.items.begin = d.data.res.first_date //开始时间

          this.calendar.items.value = d.data.res.default_date //默认有值的时间

          this.calendar.items.text = d.data.res.default_date //给日历的时间赋值默认有时间段的日期

          console.log(
            'end:' + year + '-' + months + '-' + day,
            'begin:' + d.data.res.first_date,
            'value+text:' + d.data.res.default_date
          )
          this.right_date_update = d.data.res.switch_datetime //控制详细时间段刷新的变量

          this.switch_time = d.data.res.switch_time

          this.calendar.show = false

          this.calendar.show = true

          /*let url = '/ntt/getNttTime?timezone='+this.time_zone+'&working_date='+this.calendar.items.text;

	    			this.$http.get(url)
	    			.then(d=>{
	    			})*/
        } else if (d.data.code == '75001') {
          _this.$router.replace('/pending?status=no_date')
        }
      })
    }
  }
}
</script>
<style lang='less'>
.choose_timezone {
  & > * {
    vertical-align: middle;
  }
  & > p {
    display: inline-block;
    margin: 20px 0 0 20px;
    font-size: 14px;
    line-height: 18px;
  }
}
.b_inter_wrap {
  width: 1000px;
  margin: 0 auto;
  & > img {
    padding-top: 57px;
  }
  .book_date {
    padding-top: 55px;
    & > h4 {
      font-size: 24px;
      color: #ffb400;
    }
    & > p {
      padding-top: 28px;
      font-size: 14px;
      color: #1e1e1e;
      span {
        color: #ffb400;
      }
    }
    h1.words {
      font-size: 16px;
      padding-bottom: 28px;
      font-weight: bold;
    }
    .date_detail {
      border: 1px solid #e0e0e0;
      border-radius: 5px;
      height: 500px;
      margin-top: 21px;
      & > * {
        float: left;
      }
      .calendar_wrapper {
        position: relative;
        height: 100%;
        width: 338px;
        background: #f7f7f7;
        vertical-align: middle;
      }
      .time_quantum {
        background: url('~@img/choose_bg.jpg') no-repeat right bottom;
        width: 660px;
        height: 100%;
        & > ul {
          float: left;
          padding-top: 14px;
          width: 50%;
          li:nth-child(even) {
            margin-left: 20px;
          }
          li:nth-child(odd) {
            margin-left: 26px;
          }
          & > li {
            float: left;
            margin-top: 20px;
            width: 127px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border: 1px solid #fcc800;
            border-radius: 10px;
            color: #ffb400;
            cursor: pointer;

            &:hover {
              border: 1px solid #fcc800;
              color: #1e1e1e;
              background: #fcc800;
            }
            &.active {
              border: 1px solid #fcc800;
              color: #1e1e1e;
              background: #fcc800;
            }
          }
        }
      }
      .no_date {
        p {
          text-align: center;
          margin-top: 100px;
        }
      }
    }
  }
  a.submit {
    display: block;
    cursor: pointer;
    margin: 0 auto;
    margin-top: 101px;
    margin-bottom: 145px;
    font-size: 24px;
    height: 46px;
    width: 337px;
    border-radius: 10px;
    text-align: center;
    line-height: 46px;
    background: #fcc800;
    color: #1e1e1e;
  }
  a.cancel {
    background: #cccccc;
    color: #fff;
    cursor: default;
  }
  .download {
    position: fixed;
    top: 166px;
    right: 80px;
    & > ul {
      width: 75px;
      li {
        float: left;
        margin-top: 6px;
        background-color: #fff;
        border-radius: 5px;
      }
    }
  }
}
</style>
<style lang='less'>
.book_date {
  .el-select {
    width: 300px;
    margin-top: 20px;
  }
}
</style>


// WEBPACK FOOTER //
// book.vue?191b16ae